import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import useAppStore from "store/appStore";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useSendPasswordResetOtp = () => {
	const { setFlashMessage } = useAppStore();

	const { accessToken } = useTokenStore();

	const requestOtp = async (obj) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(obj);
		const response = await instance.post(`/auth/send-reset-otp`, body);
		return response;
	};

	return useMutation(requestOtp, {
		onSuccess: async ({ data: body }) => {
			setFlashMessage(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useSendPasswordResetOtp;
